<script setup lang="ts">
import { onMounted } from 'vue'
import { useAppStore } from '@/stores/app'
import Header from '@/components/Index/Header.vue'
import Footer from '@/components/Index/Footer.vue'
import { useUserStore } from './stores/user'
// import { FloatingBubble } from 'vant'
// import { useRouter, useRoute } from 'vue-router'

const appStore = useAppStore()
const user = useUserStore()
// const router = useRouter()
// const route = useRoute()

appStore.setFingerId()

const setIsMobile = () => {
  appStore.setIsMobile(window.innerWidth < 1200)
}

if (document.cookie.includes('satoken')) {
  user.setInfo()
}

onMounted(() => {
  setIsMobile()
  window.addEventListener('resize', setIsMobile)
})

// const offset = ref({
//   x: -1,
//   y: window.innerHeight / 2 + 120,
// })

// const goBeauty = () => {
//   router.push('/beauty')
// }
</script>

<template>
  <Header />
  <div class="main-content" id="mainContent">
    <RouterView />
  </div>
  <Footer />

  <!-- <template v-if="appStore.isMobile && route.path !== '/beauty'">
    <FloatingBubble v-model:offset="offset" axis="xy" magnetic="x" :gap="0">
      <div class="beauty-icon" @click="goBeauty" />
    </FloatingBubble>
  </template> -->
</template>

<style lang="less" scoped>
.main-content {
  padding-top: 90px;
  min-height: calc(100vh - 145px);
  width: 100vw;
  box-sizing: border-box;
}
.beauty-icon {
  width: 116px;
  height: 129px;
  background: url('@/assets/images/H5/go_beauty.png') center / contain no-repeat;
}
</style>
